module.exports = __webpack_public_path__ + "static/media/graphql-swapi.4c2169f6.svg";